export enum RFQDeliveryStatus {
  NotDelivered = 0,
  Delivered = 1,
  Sending = 2,
}
